import * as React from 'react';
import { connect } from 'react-redux';
import {
  IWorkflow,
  IWorkflowStep,
  IWorkflowTrigger,
  IWorkflowCondition,
  IWorkflowExecute
} from './business-objects/common';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';
import { Form, Button, Col, Row } from 'react-bootstrap';
import WorkflowCondition from './WorkflowCondition';
import WorkflowExecute from './WorkflowExecute';

export interface IWorkflowTriggerProps {
  trigger: IWorkflowTrigger;
  steps: IWorkflowStep[];
  handleTriggerChange: (e: React.FormEvent, trigger: IWorkflowTrigger) => void;
  handleConditionChange: (
    e: React.FormEvent,
    condition: IWorkflowCondition,
    dataField: string
  ) => void;
  handleExecuteChange: (
    e: React.FormEvent,
    execute: IWorkflowExecute,
    dataField: string
  ) => void;
  addCondition: (trigger: IWorkflowTrigger) => void;
  addExecute: (trigger: IWorkflowTrigger) => void;
  removeTrigger: (id: number) => void;
  removeTriggerCondition: (id: number) => void;
  removeTriggerExecute: (id: number) => void;
}

class WorkflowTrigger extends React.Component<IWorkflowTriggerProps> {
  public render() {
    return (
      <React.Fragment>
        <br />
        <i
          title="Remove Trigger"
          className="fas fa-ban fa-lg pointer float-right"
          onClick={e => this.props.removeTrigger(this.props.trigger.id)}
        ></i>
        <Form>
          <Row>
            <Col>
              <Form.Group controlId="Name">
                <Form.Label>
                  <strong>Trigger Name</strong>
                </Form.Label>
                <Form.Control
                  type="text"
                  data-field="name"
                  placeholder="Step Name"
                  onChange={e =>
                    this.props.handleTriggerChange(e, this.props.trigger)
                  }
                  value={
                    this.props.trigger.name != null
                      ? this.props.trigger.name
                      : ''
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <br />
              <i
                title="Add Condition"
                className="fas fa-plus-square pointer float-right"
                onClick={e => this.props.addCondition(this.props.trigger)}
              ></i>
              &nbsp;&nbsp;<strong>Conditions</strong>
              {this.props.trigger.workflowTriggerConditions &&
                this.props.trigger.workflowTriggerConditions.length > 0 &&
                this.props.trigger.workflowTriggerConditions.map((x, idx) => {
                  return (
                    <WorkflowCondition
                      key={x.id}
                      condition={x}
                      idx={idx}
                      handleConditionChange={this.props.handleConditionChange}
                      removeTriggerCondition={this.props.removeTriggerCondition}
                    />
                  );
                })}
            </Col>
            <Col>
              <br />
              <i
                title="Add Action"
                className="fas fa-plus-square pointer float-right"
                onClick={e => this.props.addExecute(this.props.trigger)}
              ></i>
              &nbsp;&nbsp;<strong>Resulting Actions</strong>
              {this.props.trigger.workflowTriggerExecutes &&
                this.props.trigger.workflowTriggerExecutes.length > 0 &&
                this.props.trigger.workflowTriggerExecutes.map((x, idx) => {
                  return (
                    <WorkflowExecute
                      key={`execute${x.workflowTriggerId}.${x.id}.${idx}`}
                      execute={x}
                      steps={this.props.steps}
                      idx={idx}
                      handleExecuteChange={this.props.handleExecuteChange}
                      removeTriggerExecute={this.props.removeTriggerExecute}
                    />
                  );
                })}
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL
  };
}

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkflowTrigger);
